import { AppState } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { getBusinessHeader } from '@tock/shared/utils/AjaxActions';
import { omitBy } from 'es-toolkit/compat';

export const getActiveAuthSelector = (store: StoreType) => store.app.activeAuth;

export const getJwtTokenSelector = (store: StoreType) => store.app.jwtToken;

export const appPatronSelector = (store: StoreType) => store.app.patron;

export const businessHeaderSelector = (store: StoreType) => getFilteredBusinessHeaders(store.app);

export function getFilteredBusinessHeaders(app: AppState) {
  return omitBy(getBusinessHeader(app), (value) => value === undefined);
}

export const getApolloClientConnectionStateSelector = (store: StoreType) =>
  store.app.apolloClientConnectionState;
